import React, { useContext, useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import ButtonVintage from '@/components/common/button-vintage/ButtonVintage';
import NavLink from 'next/link';
import useAnalytic from '@/hook/useAnalytic';
import TranslationContext from '@/contexts/translation';
import styles from './gdpr-tooltip.module.scss';

const EXPIRATION = { expires: new Date(2030, 1, 1) };

const isShowed = Cookies.get('cookie_tooltip_showed') === '1';
const isEnabledMarketing = Cookies.get('cookie_marketing_is_enable') === '1';
const isEnabledStatistics = Cookies.get('cookie_statistics_is_enable') === '1';

function gtag() {
  // @ts-expect-error
  // eslint-disable-next-line
  window.dataLayer.push(arguments);
}

const GDPRTooltip = () => {
  const { translations: t } = useContext(TranslationContext);
  const language = t.getLang();

  const [isVisible, setIsVisible] = useState(false);
  const sendEvent = useAnalytic();

  // @ts-expect-error
  window.dataLayer = window.dataLayer || [];

  const init = () => {
    if (isEnabledMarketing && isEnabledStatistics && isShowed) {
      setIsVisible(false);
    } else {
      try {
        // @ts-ignore
        gtag('consent', 'default', {
          ad_storage: 'denied',
          ad_user_data: 'denied',
          ad_personalization: 'denied',
          analytics_storage: 'denied',
        });
      } catch (e) {
        sendEvent('gdpr-banner-show-error');
      }

      sendEvent('gdpr-banner-show');
      setIsVisible(true);
    }
  };

  const applyEvent = (isClose?: boolean) => {
    setIsVisible(false);

    if (isClose) {
      sendEvent('gdpr-banner-closed');
    } else {
      try {
        // @ts-ignore
        gtag('consent', 'update', {
          ad_user_data: 'granted',
          ad_personalization: 'granted',
          ad_storage: 'granted',
          analytics_storage: 'granted',
        });
      } catch (e) {
        sendEvent('gdpr-banner-accept-error');
      }

      Cookies.set('cookie_tooltip_showed', '1', EXPIRATION);
      Cookies.set('cookie_marketing_is_enable', '1', EXPIRATION);
      Cookies.set('cookie_statistics_is_enable', '1', EXPIRATION);

      sendEvent('gdpr-banner-accepted');
    }
  };

  const cookieClick = () => {
    sendEvent('cookie-policy-user-click');
  };

  const privacyClick = () => {
    sendEvent('privacy-policy-user-click');
  };

  useEffect(() => {
    init();
  }, []);

  return (
    isVisible ? (
      <div className={styles['gdpr-tooltip']}>
        <div className={styles['gdpr-tooltip-container']}>
          <div className={styles['gdpr-image']} />
          <p className={styles['text-gdpr-tooltip']}>
            {t.get('We&nbsp;use cookies according to&nbsp;your browser settings. By&nbsp;using the site, you accept the&nbsp;')}
            <NavLink
              className={styles['gdpr-link']}
              href={`${language === 'pl' ? '/pl' : ''}/terms/#cookies-policy`}
              onClick={cookieClick}
            >
              {t.get('Cookies Policy')}
            </NavLink>
            {' '}
            {t.get('and')}
            {' '}
            <NavLink
              className={styles['gdpr-link']}
              href={`/${language}/terms/#privacy-policy`}
              onClick={privacyClick}
            >
              {t.get('Privacy Policy')}
            </NavLink>
            .
          </p>
          <div className={styles['wrapper-btns-gdpr-tooltip']}>
            <div className={styles['btn-gdpr']}>
              <ButtonVintage
                variant="border"
                color="violet"
                size="s"
                text={t.get('Reject')}
                onClick={() => applyEvent(true)}
                fullWidth
              />
            </div>
            <div className={styles['btn-gdpr']}>
              <ButtonVintage
                variant="fill"
                color="violet"
                size="s"
                text={t.get('Accept')}
                onClick={() => applyEvent()}
                className={styles['btn-gdpr']}
                fullWidth
              />
            </div>
          </div>
        </div>
      </div>
    ) : null
  );
};

export default GDPRTooltip;
